module.exports = __webpack_public_path__ + "static/img/shui-3.f8ef702.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shuiBrand/shui-3.png
// module id = WrGj
// module chunks = 0